import ManageAdmission from '@/views/parametres/tarif-admissions/manage-admission'
import UnitesSoinsApi from '@/api/stock/_unites-soins'
import ExcelModal from '@/views/parametres/import-excel-modal'
import ParamTriUrgence from '@/views/parametres/tarif-admissions/param-tri-urgence'
import ManageLits from '@/views/parametres/tarif-admissions/manage-lits'
import ListesPaginees from '@/api/parametres/_listes-paginees'
import { nouvelleListe, chargerPage, rechercherDiffere } from '@/utils/liste-paginee'

import $ from 'jquery'

// Titre affiché (impression) → type d'admission côté serveur
const TYPES_PAR_TITRE = {
    'Admissions': 'admission',
    'Chambres': 'chambre',
    'Observations': 'observation'
}

export default {
    name: 'tarif-admissions',
    components: {
        ManageAdmission, ExcelModal,
        ParamTriUrgence, ManageLits
    },
    props: [],
    data() {
        return {
			can_show_assur: false,

            autre_adm_empty: false,
            autre_adm_loading: true,

            can_see_caracteristique: false,
            type_tarif_admission: '',

            save_loading: false,
            btn_disable: false,

            // Listes paginées côté serveur (15/10/2026) : une par tableau (page, recherche et chargement propres)
            admissions: nouvelleListe(),
            chambres: nouvelleListe(),
            observations: nouvelleListe(),

            admission_field: [
				{ key: 'libelle', label: 'Libellé' }, 'prix', { key: 'avec_chambre', label: 'Avec chambre' },
                { key: 'avec_observation', label: 'Avec observation' }, { key: 'facturation_acte', label: 'Facturation acte' },
                { key: 'prix_acte', label: 'Prix acte journalier' }, { key: 'actions', label: 'Action.s' }
			],

            chm_fields: [
				'libelle', 'lits', 'prix', { key: 'caracteristique', label: 'Caractéristique' },
				{ key: 'unite', label: 'Unité de soins' }, 'actions'
			],
            unites_soins: [],
            autre_fields: [
				'libelle', 'prix', { key: 'caracteristique', label: 'Caractéristique' }, 'actions'
			],

            // >>>>>>>>>>>>... Suppression
			tarif_to_be_deleted: {
				tarif_id: 0,
				libelle: ''
			},
			is_confirm: false,
			del_loading: false,
            del_disable: false,

            is_printing_autre: false,
            is_printing_hospi: false,
            filename: '',
            is_hospi: true,

            type_admission: '',
            designation: '',
            emit_action: '',
            modal_toggler: true,

            admission_to_fill: {
                user_id: 0,
                admission_id: 0,
                libelle: '',
                is_billable: 'Oui',
                prix: '',
                is_with_room: '',
                is_with_observation: '',
                facturation_acte: '',
                prix_journalier: ''
            },
            adm_modal_title: 'Nouvelle admission',
            is_edit: 0,

            type_admission_to_delete: {},

            print_title: '',
            pdf_orientation: '',
            pdf_content_width: '',

            // Impression : liste complète chargée au clic ('Admissions' | 'Chambres' | 'Observations' en cours)
            a_imprimer: [],
            impression_en_cours: '',

            // Export Excel : données construites au clic à partir de la liste complète (type en cours d'export)
            export_en_cours: '',

            admission_fields: {
                'Libellé': 'libelle',
                'Prix': 'prix',
                'Avec Chambre': 'with_room',
                'Avec Observation': 'with_observation',
                'Modèle de facturation': 'model_facturation',
                'Prix Acte Journalier': 'prix_acte_journalier'
            },

            chambre_fields: {
                'Libellé': 'libelle',
                'Prix': 'prix',
                'Caractéristique': 'caracteristique'
            },

            observation_fields: {
                'Libellé': 'libelle',
                'Prix': 'prix',
                'Caractéristique': 'caracteristique'
            },

            admission_filename: 'Liste_Admissions.xls',
            chambre_filename: 'Liste_Chambres.xls',
            observation_filename: 'Liste_Observations.xls',
            tri_toggler: 0,

            selected_chambre: {},
            toggler_lit: 0,
            can_print: false,

            c_loading_percentage: 0,
            c_refresh_timeout_id: null,
            can_view_percentage: false,
            countdown_seconds_left: 0,
            countdown_interval_id: null,

            // Rafraîchissement après import : type concerné et jeton (un seul rafraîchissement actif à la fois)
            rafraichissement: '',
            jeton_rafraichissement: 0,
        }
    },

    computed: {
        tarif_hospitalisations() {
            return this.$store.getters["tarif_hospitalisations"];
        },

        tarif_autre_admissions() {
            return this.$store.getters["tarif_autre_admissions"];
        },

        userCredentials() {
            return this.$store.getters['authInfo'];
        },
    },

    beforeDestroy() {
        // Arrête un éventuel rafraîchissement après import en cours
        this.jeton_rafraichissement++

        if (this.c_refresh_timeout_id) {
            clearTimeout(this.c_refresh_timeout_id)
            this.c_refresh_timeout_id = null
        }

        if (this.countdown_interval_id) {
            clearInterval(this.countdown_interval_id)
            this.countdown_interval_id = null
        }

        clearTimeout(this.admissions.minuteur)
        clearTimeout(this.chambres.minuteur)
        clearTimeout(this.observations.minuteur)
    },

    mounted() {
        this.chargerUnitesSoins()

        // Première page de chaque tableau
        this.chargerAdmissions()
        this.chargerChambres()
        this.chargerObservations()

        var d = new Date()
        var tmpstamp = d.getHours()+''+d.getMinutes()+''+d.getFullYear()

        this.filename = 'Liste_admission_'+tmpstamp
    },

    methods: {
        importTypeAdmission(type_admission, designation) {
            this.type_admission = type_admission
            this.designation = designation
            this.modal_toggler = (this.modal_toggler)?false:true

            if (type_admission == 'admission') {
                this.emit_action = 'emitAdmission'
            } else if (type_admission == 'chambre') {
                this.emit_action = 'emitChambre'
            } else if (type_admission == 'observation') {
                this.emit_action = 'emitObservation'
            }
            setTimeout(() => {
                $('.excel-modal-'+type_admission).modal('show')
            }, 200);
        },

        addAdmission() {
            this.adm_modal_title = 'Nouvelle admission'
            this.type_admission = 'admission'
            this.admission_to_fill = {
                user_id: this.userCredentials.id,
                admission_id: 0,
                libelle: '',
                is_billable: 1,
                prix: '',
                is_with_room: 0,
                is_with_observation: 0,
                facturation_acte: '',
                prix_journalier: '',
                type_admission: 'admission'
            }
        },

        addAutreTypeAdmission(type_admission) {
            this.adm_modal_title = 'Nouvelle '+type_admission
            this.type_admission = type_admission
            this.admission_to_fill = {
                user_id: this.userCredentials.id,
                admission_id: 0,
                is_chambre_individuelle: (type_admission == 'chambre')?"0":"",
                lits: [
                    {
                        libelle: '',
                        prix: ''
                    }
                ],
                libelle: '',
                prix: '',
                caracteristique: '',
                hospital_service_id: '',
                type_admission: type_admission
            }
            this.is_edit = 0
        },

        // Unité de soins d'une chambre : les lits ne sont proposés qu'aux soignants de cette unité.
        async chargerUnitesSoins() {
            try { this.unites_soins = await UnitesSoinsApi.liste() } catch (error) { this.unites_soins = [] }
        },

        nomUnite(id) {
            const unite = this.unites_soins.find(item => Number(item.id) === Number(id))
            return unite ? unite.name : (id ? 'Unité n° ' + id : 'Toutes les unités')
        },

        editAdmission(data, type_admission) {
            this.adm_modal_title = 'Modifier une '+type_admission
            this.type_admission = type_admission
            this.admission_to_fill = {
                user_id: this.userCredentials.id,
                admission_id: data.admission_id,
                libelle: data.libelle,
                is_billable: data.is_billable,
                prix: data.prix,
                is_with_room: data.is_with_room,
                is_with_observation: data.is_with_observation,
                facturation_acte: data.facturation_acte,
                prix_journalier: data.prix_acte_journalier,
                caracteristique: data.caracteristique,
                hospital_service_id: data.hospital_service_id || '',
                type_admission: type_admission
            }
            this.is_edit = 1
        },

        setTypeAdmissionToRemove(data, type_admission) {
            let label = ''
            if (type_admission == 'admission') {
                label = 'l\'admission'
            } else if (type_admission == 'chambre') {
                label = 'la chambre'
            } else if (type_admission == 'observation') {
                label = 'l\'observation'
            }
            this.type_admission_to_delete = {
                user_id: this.userCredentials.id,
                admission_id: data.admission_id,
                libelle: data.libelle,
                type_admission: label,
                type_del: type_admission
            }
        },

        /**
         *
         * @param {*} status 0 => Non | 1 => Oui
         */
        setStatus(status) {
            let label = ''
            switch (status) {
                case 0:
                    label = 'Non'
                    break
                case 1:
                    label = 'Oui'
                    break
            }
            return label
        },

        countdownLoad() {
            const TOTAL_SECONDS = 12 * 60

            if (this.countdown_interval_id) {
                clearInterval(this.countdown_interval_id)
                this.countdown_interval_id = null
            }

            this.countdown_seconds_left = TOTAL_SECONDS
            // Initialize percentage based on full remaining time
            this.c_loading_percentage = 100

            this.countdown_interval_id = setInterval(() => {
                if (this.countdown_seconds_left > 0) {
                    this.countdown_seconds_left--
                    // Update loading percentage according to remaining time
                    this.c_loading_percentage = (this.countdown_seconds_left / TOTAL_SECONDS) * 100
                } else {
                    clearInterval(this.countdown_interval_id)
                    this.countdown_interval_id = null
                    this.c_loading_percentage = 0
                }
            }, 1000)
        },

        /**
         * Après un import : recharge la page courante du tableau concerné, puis recommence toutes les 5 s tant que
         * la liste reste vide (au plus pendant le compte à rebours de countdownLoad)
         * @param {String} data_type admission | chambre | observation
         */
        rafraichirApresImport(data_type) {
            if (this.c_refresh_timeout_id) {
                clearTimeout(this.c_refresh_timeout_id)
                this.c_refresh_timeout_id = null
            }

            const jeton = ++this.jeton_rafraichissement
            this.rafraichissement = data_type
            this.can_view_percentage = true

            const liste = this.listeParType(data_type)
            this.chargerListe(data_type).then(() => {
                // Écran quitté ou autre import terminé entre-temps
                if (jeton !== this.jeton_rafraichissement) {
                    return
                }

                if (liste.total > 0 || this.countdown_seconds_left == 0) {
                    this.rafraichissement = ''
                    this.can_view_percentage = false
                    if (this.countdown_interval_id) {
                        clearInterval(this.countdown_interval_id)
                        this.countdown_interval_id = null
                    }
                    return
                }

                this.c_refresh_timeout_id = setTimeout(() => {
                    this.rafraichirApresImport(data_type)
                }, 5000)
            })
        },

		loadEmitChambre() {
            this.countdownLoad()
            this.rafraichirApresImport('chambre')
        },

        loadEmitObservation() {
            this.countdownLoad()
            this.rafraichirApresImport('observation')
        },

        loadEmitAdmission() {
            this.countdownLoad()
            this.rafraichirApresImport('admission')
        },

        /**
         * Liste paginée d'un type d'admission
         * @param {String} data_type admission | chambre | observation
         */
        listeParType(data_type) {
            if (data_type == 'chambre') {
                return this.chambres
            } else if (data_type == 'observation') {
                return this.observations
            }
            return this.admissions
        },

        /**
         * Charge la page courante d'un tableau (pagination et recherche côté serveur)
         * @param {String} data_type admission | chambre | observation
         */
        chargerListe(data_type) {
            const liste = this.listeParType(data_type)
            const appel = params => ListesPaginees.typesAdmission(data_type, params)

            return chargerPage(liste, appel).then(() => {
                // Page devenue vide (ex. suppression du dernier élément de la dernière page) : retour à la dernière page
                if (!liste.chargement && !liste.erreur && liste.lignes.length === 0 && liste.page > 1 && liste.total > 0) {
                    liste.page = Math.ceil(liste.total / liste.per_page)
                    return chargerPage(liste, appel)
                }
            })
        },

        chargerAdmissions() {
            return this.chargerListe('admission')
        },

        chargerChambres() {
            return this.chargerListe('chambre')
        },

        chargerObservations() {
            return this.chargerListe('observation')
        },

        /**
         * Recherche serveur (libellé, caractéristique) après la fin de la saisie
         */
        rechercher(data_type) {
            rechercherDiffere(this.listeParType(data_type), () => this.chargerListe(data_type))
        },

        /**
         * Le tableau (recherche, pagination) reste affiché pendant les rechargements ; il est remplacé par le
         * message « Aucune donnée » seulement si la liste est vide sans recherche
         */
        aDesDonnees(liste) {
            return liste.total > 0 || liste.q !== ''
        },

        /**
         * Liste complète d'un type d'admission (sans pagination), pour l'impression et l'export
         */
        chargerListeComplete(data_type) {
            return this.$store.dispatch("getListeTypeAdmission", data_type).then(liste => liste || [])
        },

        /**
         * Données de l'export Excel, construites au clic à partir de la liste complète
         * (appelé par la prop `fetch` de export-excel ; un tableau vide annule le téléchargement)
         */
        exporterListe(data_type, transformer) {
            if (this.export_en_cours) {
                return Promise.resolve([])
            }

            this.export_en_cours = data_type
            return this.chargerListeComplete(data_type).then(liste => liste.map(transformer)).catch(() => {
                this.errorToast("Impossible de charger la liste à exporter. Veuillez réessayer.")
                return []
            }).finally(() => {
                this.export_en_cours = ''
            })
        },

        exporterAdmissions() {
            return this.exporterListe('admission', admission => ({
                'libelle' : admission.libelle,
                'prix' : (admission.prix > 0)?admission.prix:'',
                'with_room': (admission.is_with_room == 1)?'OUI':'NON',
                'with_observation': (admission.is_with_observation == 1)?'OUI':'NON',
                'model_facturation': (admission.facturation_acte != null)?admission.facturation_acte:'',
                'prix_acte_journalier': (admission.prix_acte_journalier > 0)?admission.prix_acte_journalier:''
            }))
        },

        exporterChambres() {
            return this.exporterListe('chambre', chambre => ({
                'libelle' : chambre.libelle,
                'prix' : (chambre.prix > 0)?chambre.prix:'',
                'caracteristique': chambre.caracteristique
            }))
        },

        exporterObservations() {
            return this.exporterListe('observation', observation => ({
                'libelle' : observation.libelle,
                'prix' : (observation.prix > 0)?observation.prix:'',
                'caracteristique': observation.caracteristique
            }))
        },

        /**
         * Impression : charge la liste complète du type demandé puis imprime toutes les lignes
         * @param {String} type_admission Admissions | Chambres | Observations
         */
        setTypeAdmissionToPrint(type_admission) {
            if (this.impression_en_cours) {
                return
            }

            this.impression_en_cours = type_admission
            this.chargerListeComplete(TYPES_PAR_TITRE[type_admission]).then((liste) => {
                this.a_imprimer = liste
                this.print_title = type_admission

                this.can_print = true
                setTimeout(() => {
                    window.print()

                    this.can_print = false
                    this.a_imprimer = []
                    this.impression_en_cours = ''
                }, 500);
            }).catch(() => {
                this.impression_en_cours = ''
                this.errorToast("Impossible de charger la liste à imprimer. Veuillez réessayer.")
            })
        },

        manageLit(data) {
            this.toggler_lit = (this.toggler_lit == 0)?1:0

            this.selected_chambre = data

            $('.manage-lit').modal('show')
        },
    }
}


